import React from "react";
import FAQAccordion from '../FAQAccordion';

class BlueRidgeParkwayInfo extends React.Component {
  render() {
    return (
      <React.Fragment>
        <section className="about-us pt-trip">
          <div className="container">

            <p>
              The Blue Ridge Parkway stretches 469 miles from Shenandoah National Park in Virginia to Great Smoky Mountains National Park in North Carolina — the longest linear park in the United States. With no trucks, no billboards, and a 45 mph speed limit, it's designed entirely for the experience of driving through the Appalachian highlands at a human pace.
            </p>
            <p>
              Every season brings something different: wildflowers in spring, dense green tunnels in summer, the most spectacular fall foliage on the East Coast in October, and quiet solitude in winter. The 5-day itinerary below runs north to south from Waynesboro, VA to Asheville, NC — roughly the full parkway's highlights compressed into a week.
            </p>

            <div className="xinfo-card">
              <div className="xinfo-card-body">
                <p className="xinfo-card-label">Most Photographed Stop</p>
                <h3 className="xinfo-card-title">Mabry Mill</h3>
                <p className="xinfo-card-price">Free · Milepost 176.1</p>
                <p className="xinfo-card-desc">
                  The most photographed spot on the entire Blue Ridge Parkway. This restored 19th-century grist mill and sawmill sits beside a millpond surrounded by wildflowers in summer and blazing foliage in fall. On weekends from May through October, craftspeople demonstrate blacksmithing, woodworking, and cornmeal grinding — a living history of Appalachian mountain life.
                </p>
              </div>
            </div>

            <h2>Blue Ridge Parkway Trip Overview</h2>
            <ul>
              <li><strong>Total distance:</strong> 469 miles</li>
              <li><strong>This itinerary:</strong> 5 days, Waynesboro VA to Asheville NC</li>
              <li><strong>Entry fee:</strong> Free (no toll or entry fee)</li>
              <li><strong>Best months:</strong> October (foliage), May–June (wildflowers)</li>
              <li><strong>Speed limit:</strong> 45 mph maximum — plan for slow, scenic driving</li>
            </ul>

            <h2>Days 1–2 — Virginia Section</h2>
            <p>
              Enter the parkway at Rockfish Gap (Milepost 0) near Waynesboro. The first stop is <strong>Humpback Rocks</strong> (Milepost 5.8) — a short but steep 2-mile hike to a rocky summit with sweeping valley views. The visitor center here has a restored 19th-century mountain farm.
            </p>
            <p>
              Continue south to <strong>Peaks of Otter</strong> (Milepost 86) — a lodge, restaurant, and lake set between two peaks. Hike Sharp Top (3.2 miles round trip, strenuous) for one of the finest views in Virginia. Spend the night at Peaks of Otter Lodge or in Bedford below. Next morning, continue to <strong>Mabry Mill</strong> (Milepost 176) for the classic photo and a buckwheat pancake breakfast on weekends.
            </p>

            <h2>Days 3–4 — North Carolina Highlands</h2>
            <p>
              Cross into North Carolina and stop at <strong>Doughton Park</strong> (Milepost 238) for wildflower meadows and the Bluff Mountain Trail. Then continue to <strong>Linville Falls</strong> (Milepost 316) — one of the most spectacular waterfalls in the Appalachians, accessible via a 2-mile round-trip trail with multiple viewpoints above the gorge.
            </p>
            <p>
              The next day, visit <strong>Grandfather Mountain</strong> (Milepost 305, with a separate entrance fee of ~$25) — home to the famous Mile High Swinging Bridge at 5,305 feet, the highest suspension footbridge in North America. The wildlife habitats here house black bear, cougar, and bald eagles. Continue to <strong>Linn Cove Viaduct</strong> (Milepost 304), an engineering marvel snaking around the side of Grandfather Mountain.
            </p>

            <h2>Day 5 — Craggy Gardens & Asheville</h2>
            <p>
              The final stretch into Asheville passes through <strong>Craggy Gardens</strong> (Milepost 364), blanketed with Catawba rhododendrons that bloom brilliant purple in mid-June. Walk the short trail to Craggy Pinnacle for panoramic views. End at the <strong>Folk Art Center</strong> (Milepost 382) near Asheville for Southern Appalachian crafts, then head into Asheville's vibrant downtown for dinner and a well-earned local beer.
            </p>

            <FAQAccordion
              title="Blue Ridge Parkway FAQs"
              items={[
                { q: 'Is there a fee to drive the Blue Ridge Parkway?', a: 'No — the Blue Ridge Parkway has no entry fee or toll. Some attractions along the way (like Grandfather Mountain) charge separate admission.' },
                { q: 'When is the best time to drive the Blue Ridge Parkway?', a: 'Mid-October for peak fall foliage is the most popular time. Late May–June for rhododendron blooms is the second best. Avoid October weekends if you want fewer crowds.' },
                { q: 'How long does it take to drive the entire Blue Ridge Parkway?', a: 'The full 469 miles takes 5–7 days if you stop at the highlights. Non-stop with no detours takes about 10 hours, but that defeats the entire purpose of the drive.' },
                { q: 'Are there gas stations on the Blue Ridge Parkway?', a: 'Very few — fill up at towns before getting on the parkway. Gas stations are located in gateway towns at major mileposts but are not on the parkway itself.' },
                { q: 'Can you camp on the Blue Ridge Parkway?', a: 'Yes — there are 9 NPS campgrounds along the parkway, ranging from primitive to developed. Otter Creek, Peaks of Otter, and Linville Falls are among the most popular. Reserve via recreation.gov in summer.' },
                { q: 'What is the most scenic section of the Blue Ridge Parkway?', a: 'The North Carolina section from Linville Falls (MP 316) to Craggy Gardens (MP 364) is generally considered the most dramatic, with deep gorges, high peaks, and rhododendron tunnels.' },
              ]}
            />

          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default BlueRidgeParkwayInfo;
